/**
* Featured Left Right JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Left Right component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'featured-left-right',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      if ( window.innerWidth > 1024 && window.hasMotion ) {
        $( '.featured-left-right' ).each( function( key, val ) {
          const image = $( this ).find( '.drawing-image' )[0];
          const height = $( this ).outerHeight();

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top 50%',
              end: 'bottom 50%',
              scrub: 0,
            },
          } );
          tl.to( image, {y: '33%', ease: 'linear'}, 0 );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-left-right', COMPONENT );
} )( app );
